<template>
  <b-button
    :size="size"
    variant="success"
    :disabled="disabled || loading"
    @click="downloadExcel"
  >
    <i class="fas fa-file-excel" /> Exportar <b-spinner class="align-middle ml-1" small v-if="loading" />
  </b-button>
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api'
import XLSX from 'xlsx-color'

// components
import Loading from '@/components/Loading.vue'

// utils
import { alerts } from '@/utils'
import excelHelpers from '../helpers/excel'

export default defineComponent({
  name: 'ButtonExport',
  components: {
    Loading
  },
  props: {
    size: {
      type: String,
      default: 'sm'
    },
    headers: {
      type: Array,
      required: true
    },
    headerKeyText: {
      type: String,
      default: 'text'
    },
    keyValue: {
      type: String,
      default: 'value'
    },
    items: {
      type: Array,
      required: true
    },
    getItemsAction: {
      type: Function,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const loading = ref(false)
    const createExcel = () => {
      const data = []
      const nameSheet = 'sheet'
      let indexLetter = ''
      data.push(props.headers.map((header, index) => {
          const [first, position] = excelHelpers.findPosition(index, indexLetter)
          indexLetter = first
          header.position = `${position}1`
        return header[props.headerKeyText]
      }))
      props.items.forEach(row => {
        data.push(props.headers.map(col => {
          const key = col[props.keyValue]
          const keySplit = key.split('.')
          let value = null
          if (keySplit.length > 1) {
            keySplit.forEach(k => {
              if (value === null) {
                value = row[k]
              } else {
                value = value[k]
              }
            })
            return value
          } else {
            value = row[key]
          }
          if (col.formatter) {
            return col.formatter(value)
          }
          return value
        }))
      })

      const newWorkbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.aoa_to_sheet(data, {
        cellStyles: true
      })

      props.headers.filter(h => h.bgColor).forEach(h => {
        worksheet[h.position].s = {
          fill: {
            patternType: 'solid',
            fgColor: {
              rgb: h.bgColor
            }
          }
        }
      })

      XLSX.utils.book_append_sheet(newWorkbook, worksheet, nameSheet)
      XLSX.writeFile(newWorkbook, `${props.name}.xlsx` || 'document.xlsx', {
        cellStyles: true
      })
      loading.value = false
    }
    const downloadExcel = async () => {
      loading.value = true
      if (props.getItemsAction) {
        await props.getItemsAction()
      }
      setTimeout(() => {
        if (props.items.length > 0) {
          createExcel()
        } else {
          alerts.error('No se puede descargar Excel sin nigún dato.!')
          loading.value = false
        }
      }, 500)
    }
    return {
      downloadExcel,
      loading
    }
  }
})
</script>
